import React from 'react'
import { BaseView } from '@/components/base'
import { ArrowDownCircle } from '@/assets/icons'
import { useTheme } from '@/hooks/useTheme'

interface TransferInAvatarProps {
  size?: number
  iconSize?: number
}

export const TransferInAvatar: React.FC<TransferInAvatarProps> = ({
  size = 140,
  iconSize = 68,
}) => {
  const theme = useTheme()

  return (
    <BaseView
      center
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        background: `linear-gradient(135deg, ${theme.colors.background.secondaryBlue || '#3B82F6'} 0%, ${theme.colors.background.secondaryBlue || '#1D4ED8'} 100%)`,
        position: 'relative',
        boxShadow: '0 8px 32px rgba(59, 130, 246, 0.3)',
      }}
    >
      <ArrowDownCircle size={iconSize} color="white" />
    </BaseView>
  )
}
